import { Grid, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { useEffect, useState } from "react";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import "../../assets/css/App.css";
import imageError from '../../assets/img/system_fail2.png';
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { Path } from "../../utils/Constant";
import { padGinUnit, widthUnit } from "../../utils/DeviceManager";

function NotFoundScreen(props : any) {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const path = window.location.pathname
    const [msg, setMsg] = useState(path === Path.expired ? "ลิงค์หมดอายุ หรือไม่มีอยู่อีกต่อไป" : "ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้\nกรุณาลองอีกครั้ง")

    useEffect(() => {
        window.document.title = "ไม่พบหน้าที่ต้องการ - ไชโย"
        const params = props.match.params.msg;
        if (params){
            setMsg(params)
        }
    }, [props.match.params.msg])

    const notFoundWidget = () => {
        return (
            <div style={{
                    alignContent: "center", 
                    position: 'fixed',  marginRight: '20px', width: '100%'
            }}>
                <Grid container direction="column" justifyContent="center" alignItems="center">
                    <Grid item >
                        <img width={!isDesktop? window.innerWidth : widthUnit(window.innerWidth*0.3)} src={imageError} alt={"error"}/>
                    </Grid>
                    <Grid item xs={12}>
                        <DynamicTitle title={"ขออภัย"} size={32} isFull={true} color={AcnColorTheme.darkBlue}/>
                    </Grid>
                    <Grid item xs={12} style={{marginTop: 12, paddingLeft: padGinUnit(24), paddingRight: padGinUnit(24)}}>
                        <Typography style={{color: AcnColorTheme.black, whiteSpace: 'pre-line'}}>
                            {msg}
                        </Typography>
                    </Grid>
                </Grid>
            </div>
        );
    }

    return (
        <TemplateComponent content={notFoundWidget()}
                           background={AcnColorTheme.primary}
                           noPadding
                           showHeadBar={false}
                           footerText="กดปุ่มปิดเพื่อกลับไปหน้าแชทหลัก"
        />
    );
}

export default NotFoundScreen;
